package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.DigicodeRepository

/**
 * Use case for timing out a digicode challenge.
 * Triggered by the player-side countdown when time runs out.
 */
class TimeoutDigicodeUseCase(
    private val digicodeRepository: DigicodeRepository
) {
    suspend operator fun invoke(
        digicodeId: String
    ): Result<Unit> {
        return digicodeRepository.timeout(
            digicodeId = digicodeId
        )
    }
}
